import { useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useOrderGetNewSchemaQuery } from 'api/generated/graphql';
import { parseOrderSchema, useError } from 'api/helpers';
import { OrderSchema } from 'api/types/data';

import { RequestOptions } from '../types';

export const useOrderGetNewSchema = (options?: RequestOptions) => {
  const {
    data,
    loading,
    error: apolloError,
  } = useOrderGetNewSchemaQuery(options);

  const error = useError(apolloError);

  const orderSchema = useMemo((): OrderSchema | undefined => {
    if (!data?.orderSchema) {
      return undefined;
    }
    return parseOrderSchema(data.orderSchema);
  }, [data?.orderSchema]);

  return {
    orderSchema,
    loading,
    error,
  };
};
